export function returnRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_RETURN_PRODUCT_START":           
        case "FETCH_RETURN_PRODUCT_START":           
        case "DELETE_RETURN_PRODUCT_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_RETURN_PRODUCT_FULFILLED":           
        case "FETCH_RETURN_PRODUCT_FULFILLED":           
        case "DELETE_RETURN_PRODUCT_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_RETURN_PRODUCT_ERROR":
        case "FETCH_RETURN_PRODUCT_ERROR":
        case "DELETE_RETURN_PRODUCT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}